import axios from 'axios';

const isLocal = window.location.hostname === "localhost";

// 1. BACKEND_URL debe ser solo la raíz del servidor
export const BACKEND_URL = isLocal 
  ? "http://localhost:8080" 
  : "https://sapphirespell-801597775570.us-central1.run.app";

// 2. API le agrega el prefijo /api correctamente una sola vez
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
